module.exports = __webpack_public_path__ + "static/media/bgheroprovide.c9b60735.webp";